"use client";

import { User } from "@/lib/user/user.type";
import { redirect, usePathname } from "next/navigation";
import { useLayoutEffect } from "react";

type PropsType = {
  profile: User | null;
};
export const AuthRedirect = ({ profile }: PropsType) => {
  const pathname = usePathname();

  useLayoutEffect(() => {
    if (profile) {
      if (!pathname.includes("/v2")) {
        return redirect("/v2");
      }
    }
  }, [profile, pathname]);

  return null; // No UI needed, just redirect logic
};
